import React from 'react';

const Footer = () => (
  <div className="mt-4">
    <p className="dark:text-gray-200 text-gray-700 text-center pb-5">
      © 2025 All rights reserved by Riddhi Education Trust Developed By <a href="https://www.tridevitsolution.com">Tridev IT Solution</a>
    </p>
  </div>
);

export default Footer;